
import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

interface PlaceholderPageProps {
  title: string;
  description?: string;  // Changed from subtitle to description to match existing usage
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-24 md:pt-32">
        <div className="container px-4 md:px-6 py-12 md:py-20">
          <Link 
            to="/" 
            className="inline-flex items-center mb-6 text-figgy-600 hover:text-figgy-700 transition-colors"
          >
            <span className="mr-2">⬅️</span>
            Back to Home
          </Link>
          
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{title}</h1>
          {description && (
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl">
              {description}
            </p>
          )}
          
          <div className="bg-figgy-50 border border-figgy-100 rounded-lg p-8 text-center">
            <p className="text-figgy-800 mb-2">This page is coming soon! 🚧</p>
            <p className="text-muted-foreground">
              We're currently working on this content. Check back later!
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
